/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `DRAFT` - Draft
 *   * `CREATED` - Created
 *   * `PAID` - Paid
 * ```
 */
export const ServiceOrderListStateEnum = {
  DRAFT: 'DRAFT',
  CREATED: 'CREATED',
  PAID: 'PAID',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ServiceOrderListStateEnum = ValuesOf<typeof ServiceOrderListStateEnum>;

export type ServiceOrderListStateEnumRequest = ServiceOrderListStateEnum;
export type ServiceOrderListStateEnumResponse = ServiceOrderListStateEnum;
